import store from "@/store";
import { getFinancialList } from '../../api/backoffice';
import {FINANCIAL_IDS} from "@/enums/financials/financialIds";

let financialNationalityMap = [
    //BBVA PT / BPI
    {
        "nationality": "PT",
        "financialIds": [
            FINANCIAL_IDS.BBVA, 
            FINANCIAL_IDS.SANTANDER_CONSUMER, 
            FINANCIAL_IDS.BPI, 
            FINANCIAL_IDS.CGD, 
            FINANCIAL_IDS.CETELEM, 
            FINANCIAL_IDS.CREDIBOM, 
            FINANCIAL_IDS.BMW_FS,
        ]
    },
    //BBVA ES / Sofinco
    {
        "nationality": "ES",
        "financialIds": [
            FINANCIAL_IDS.BBVA_ESPANHA, 
            FINANCIAL_IDS.SOFINCO, 
            FINANCIAL_IDS.CAIXABANK, 
            FINANCIAL_IDS.CETELEM_ES, 
            FINANCIAL_IDS.SABADELL, 
            FINANCIAL_IDS.SANTANDER_CONSUMER_ES
        ]
    }
];

/**
 * Carrega dinamicamente o mapa de nacionalidades das financeiras
 * @returns {Promise<Array>} Array com mapeamento de nacionalidade e IDs
 */
async function loadFinancialNationalityMap() {
    try {
        const idInstance = store.getters["AuthenticationModule/getUserInstanceId"] || -1;
        const response = await getFinancialList(idInstance);

        if (response?.data && Array.isArray(response?.data?.data)) {
            // Agrupa financeiras por nacionalidade
            const groupedByNationality = response?.data?.data.reduce((acc, financial) => {
                const nationality = financial.NATIONALITY;
                
                if (!acc[nationality]) {
                    acc[nationality] = [];
                }
                
                acc[nationality].push(financial.ID);
                
                return acc;
            }, {});
            
            // Converte o objeto agrupado em array no formato esperado
            financialNationalityMap = Object.entries(groupedByNationality).map(([nationality, financialIds]) => ({
                nationality,
                financialIds
            }));
        }
        
        return financialNationalityMap;
    } catch (error) {
        console.error('Erro ao carregar mapa de nacionalidades:', error);
        return financialNationalityMap; // Retorna o mapa estático em caso de erro
    }
}

const useFinancialNationality = (nationality) => financialNationalityMap.find((financialMapper) => financialMapper.nationality === nationality)?.financialIds || [];

/**
 * Obtém a nacionalidade de uma financeira pelo ID
 * @param {number} financialId - ID da financeira
 * @returns {string|undefined} Nacionalidade ou undefined se não encontrado
 */
function getFinancialNationality(financialId) {
    return financialNationalityMap.find((mapper) => 
        mapper.financialIds.includes(financialId)
    )?.nationality;
}

const spanishFinancials = [12, 13, 15, 16, 17, 18];//TODO: verificar depois

export {
    financialNationalityMap, 
    useFinancialNationality, 
    loadFinancialNationalityMap,
    getFinancialNationality,
    spanishFinancials,
}